import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <Marker2D> positions its children and draws Godot's "+" editor cross at its origin for every
 * node, in full colour (`marker_2d.cpp:47-59,85`, ADR-0056): a red x axis and a green y axis, each
 * negative half darkened.
 */
import { useMemo } from 'react';
import { Node2D } from '../../base/node2d/Component';
import { GizmoLine } from '../../../r3f/components/GizmoLine';
import { useGizmoDrawn } from '../../../r3f/hooks/useGizmoState';
import { Vector3Axis } from '../../../godot/math/vector3Axis';
import { writeGodotPointAsThree } from '../../../r3f/node2dTransform';
import { FLOATS_PER_VERTEX } from '../../../godot/math/vector';
import { axisCross } from '../../../r3f/gizmo/axisCross';
const { X, Y } = Vector3Axis;
export function Marker2D({ node, children }) {
    const props = node.properties;
    const drawsCross = useGizmoDrawn('every-node');
    return (_jsxs(Node2D, { node: node, children: [drawsCross && _jsx(MarkerCross, { extents: props.gizmo_extents }), children] }));
}
function crossInGroupSpace(extents) {
    const { positions, colors } = axisCross(extents, [X, Y]);
    const inGroupSpace = new Float32Array(positions.length);
    for (let i = 0; i < positions.length; i += FLOATS_PER_VERTEX) {
        writeGodotPointAsThree(inGroupSpace, i, positions[i], positions[i + Y]);
    }
    return { positions: inGroupSpace, colors };
}
function MarkerCross({ extents }) {
    const { positions, colors } = useMemo(() => crossInGroupSpace(extents), [extents]);
    return _jsx(GizmoLine, { positions: positions, colors: colors });
}
//# sourceMappingURL=Component.js.map